import React from "react";
import get from "lodash/get";

const Bool = ({ row, name }) => {
  let value = get(row, name, "");
  value = Array.isArray(value) ? value.length != 0 : value;

  return value ? <em className="fa-regular fa-check"></em> : null;
};

export default Bool;
